import React, { useEffect, useState } from 'react';
import { ILegalTransactionRelationshipRealEstate } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import { Delete, MenuBook } from '@mui/icons-material';
import { ILegalTransactionRelationship } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { LandregisterSerach } from '../DocumentDirectory/LandregisterSerach';
import { IDocument } from '../../Interfaces/IDocument';
import { ILegalTransactionFullObject } from '../../Interfaces/ILegalTransaction';
import { IDocumentDirectoryHasDocument } from '../../Interfaces/IDocumentDirectoryHasDocument';
import { IDocumentDirectory } from '../../Interfaces/IDocumentDirectory';
import { usePurchaseContractMeta } from '../PurchaseContract/hooks/usePurchaseContractMeta';
import { RealEstateEditDialog } from '../ProcessManager/RealEstateEditDialog';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { LandRegisterMainQueryDocument } from './LandRegisterMainQueryDocument';
import { ILandParcelEntry } from '../../Interfaces/IRealEstate';
import { ICourt } from '../../Interfaces/ICourt';
import { IAdminstrativeUnit } from '../../Interfaces/IAdminstrativeUnit';
import { ICourtAdminstrativeUnitAssignment } from '../../Interfaces/ICourtAdminstrativeUnitAssignment';
import { QueryLandRegisterDialog } from './QueryLandRegisterDialog';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';
import { LegalTransactionRelationshipTypeEnum } from '../../Interfaces/ILegalTransactionRelationship/LegalTransactionRelationshipTypeEnum';
import { ILegalTransactionRelationshipDataPurchaseContractV1 } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipData';
import { useGetRealEstateLandRegisterEntryQueryByRealEstate } from '../../hooks/reactQuerys/RealEstateQueries';
import { GrundbuchblattEditDialog } from '../../Grundstuecke/GrundbuchblattEditDialog';
import { useBlattForRealEstate } from '../../hooks/reactQuerys/GrundbuchblattQueries';

interface IProps {
  index: number;
  legalTransaction: ILegalTransactionFullObject;
  relationship: ILegalTransactionRelationship;
  realEstate: ILegalTransactionRelationshipRealEstate;
  realEstateArray: ILegalTransactionRelationshipRealEstate[];
  setRealEstateArray: Function;
  documentArray: IDocumentDirectoryHasDocument[];
  documentDirectoryArray: IDocumentDirectory[];
  setDocumentArray: Function;
  setDocumentDirectoryArray: Function;

  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  setLegalPhaseFullObjectArray: Function;
  legalReqStates: ILegalRequirementState[];

  courts: ICourt[];
  adminUnit: IAdminstrativeUnit[];
  courtsAdminAssign: ICourtAdminstrativeUnitAssignment[];
}

export const LandRegisterQueryRow: React.FC<IProps> = ({
  index,
  legalTransaction,
  relationship,
  realEstate,
  realEstateArray,
  setRealEstateArray,
  documentArray,
  documentDirectoryArray,
  setDocumentArray,
  setDocumentDirectoryArray,

  legalPhaseFullObjectArray,
  setLegalPhaseFullObjectArray,
  legalReqStates,

  courts,
  adminUnit,
  courtsAdminAssign,
}) => {
  const {
    realEstateLandRegisterEntryQueries,
    isLoadingRealEstateLandRegisterEntryQueries,
    refetchRealEstateLandRegisterEntryQueries,
  } = useGetRealEstateLandRegisterEntryQueryByRealEstate(
    realEstate.idRealEstate
  );
  const [isOpenLandregisterSerach, setOpenLandregisterSerach] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenToReq, setIsOpenToReq] = useState(false);
  //
  const [localData, setLocalData] = useState<null | IDocument>(null);
  //
  const [editRealEstate, setEditRealEstate] = useState(realEstate);
  //
  const [value, setValue] = useState('0');
  // Neues Grundbuchblatt (Bestandsverzeichnis + Abteilungen) zu diesem
  // Grundstück auflösen + Tab-Editor öffnen.
  const { resolvedIdGrundbuchblatt } = useBlattForRealEstate(
    realEstate.idRealEstate
  );
  const [isOpenBlatt, setIsOpenBlatt] = useState(false);

  const reason =
    relationship.idRelationshipType ===
      LegalTransactionRelationshipTypeEnum.LandRegisterQuery &&
    (
      relationship.data as ILegalTransactionRelationshipDataPurchaseContractV1
    ).ReasonLandRegisterQueryArray?.find((res, idx) => idx === index);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  useEffect(() => {
    console.log(value);
  }, [value]);

  const callOnSuccess = (
    docArray: IDocument[],
    landParcelEntryArray: ILandParcelEntry[]
  ) => {
    if (docArray.length > 0) {
      //setLocalData(docArray[docArray.length - 1]);
      //setIsOpenToReq(true);
      const updatedObject = {
        ...editRealEstate,
        LandParcelEntryArray: editRealEstate.LandParcelEntryArray.map(
          parcelParent => {
            const found = landParcelEntryArray.find(
              parcelUpdated =>
                parcelUpdated.idRealEstateLandRegisterEntry ===
                parcelParent.idRealEstateLandRegisterEntry
            );
            return found ?? parcelParent;
          }
        ),
      };

      setEditRealEstate(updatedObject);
      setRealEstateArray([
        ...realEstateArray.map(rel =>
          rel.idRealEstate === updatedObject.idRealEstate ? updatedObject : rel
        ),
      ]);
    }
  };

  const {
    isLoading,
    isNoData,
    propertyTypes,
    inventoryOptions,
    realEstateUseTypes,
    purchaseContractRelationTypes,
  } = usePurchaseContractMeta();

  const onClose = () => {
    setIsOpenEdit(false);
  };

  const saveObject = (localObject: ILegalTransactionRelationshipRealEstate) => {
    setRealEstateArray([
      ...realEstateArray.map(rel =>
        rel.idRealEstate === localObject.idRealEstate ? localObject : rel
      ),
    ]);
  };

  const onSave = () => {
    saveObject(editRealEstate);
    onClose();
  };

  return (
    <>
      {isOpenLandregisterSerach && (
        <Dialog
          open
          onClose={() => setOpenLandregisterSerach(false)}
          maxWidth='lg'
          fullWidth
        >
          <DialogContent>
            <LandregisterSerach
              idLegalTransaction={legalTransaction.idLegalTransaction}
              documentArray={documentArray}
              documentDirectoryArray={documentDirectoryArray}
              setDocumentArray={setDocumentArray}
              setDocumentDirectoryArray={setDocumentDirectoryArray}
              landParcelEntry={realEstate.LandParcelEntryArray[0]}
              addressSearchString={
                realEstate.Street == undefined && realEstate.StreetNr
                  ? realEstate.StreetNr
                  : realEstate.Street && realEstate.StreetNr == undefined
                    ? realEstate.Street
                    : realEstate.Street && realEstate.StreetNr
                      ? `${realEstate.Street} ${realEstate.StreetNr}`
                      : undefined
              }
              callOnSuccess={callOnSuccess}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant='contained'
              onClick={() => setOpenLandregisterSerach(false)}
            >
              Schließen
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {isOpenToReq && localData && (
        <Dialog
          open
          onClose={() => setIsOpenToReq(false)}
          maxWidth='lg'
          fullWidth
        >
          <DialogContent>
            Ihr Grundbuchauszug {localData.FileName} wurde erfolgreich
            abgerufen.
            <br />
            Möchten Sie den Grundbuchauszug in einer Bedingung hinterlegen,
            damit der Mandant ihn über das Portal beziehen kann?
            <FormControl>
              <FormLabel id='demo-radio-buttons-group-label'>Gender</FormLabel>
              <RadioGroup
                name='radio-buttons-group'
                value={value}
                onChange={handleChange}
              >
                <Grid container spacing={2}>
                  {legalPhaseFullObjectArray.map(phase => (
                    <>
                      <Grid item xs={12}>
                        {phase.LegalPhase}
                      </Grid>
                      {phase.LegalRequirementArray.map(req => (
                        <>
                          <Grid item xs={4}>
                            <Radio value={req.idLegalRequirement} />
                          </Grid>
                          <Grid item xs={8}>
                            {req.LegalRequirement}
                          </Grid>
                        </>
                      ))}
                    </>
                  ))}
                </Grid>
              </RadioGroup>
            </FormControl>
          </DialogContent>
        </Dialog>
      )}

      {isOpenEdit && !isLoading && !isNoData && (
        <RealEstateEditDialog
          realEstate={editRealEstate}
          onSave={updated => {
            setEditRealEstate(updated);
            saveObject(updated);
            onClose();
          }}
          onClose={onClose}
          legalTransaction={legalTransaction}
          legalPhaseFullObjectArray={legalPhaseFullObjectArray}
          setLegalPhaseFullObjectArray={setLegalPhaseFullObjectArray}
          legalReqStates={legalReqStates}
        />
      )}

      {isOpenBlatt && (
        <GrundbuchblattEditDialog
          open={isOpenBlatt}
          idGrundbuchblatt={resolvedIdGrundbuchblatt}
          onClose={() => setIsOpenBlatt(false)}
        />
      )}

      <TableRow>
        {/* Amtsgericht (+ Begründung darunter) */}
        <TableCell>
          {Array.from(
            new Set(
              realEstate.LandParcelEntryArray.map(
                landParcel =>
                  courts.find(court => court.idCourt === landParcel.idCourt)
                    ?.Court
              ).filter(Boolean)
            )
          ).join(', ') || '–'}
          {reason && reason.Reason ? (
            <div style={{ fontSize: '0.8em', color: 'rgba(0,0,0,0.6)' }}>
              {reason.Reason}
            </div>
          ) : null}
        </TableCell>
        {/* Gemarkung */}
        <TableCell sx={{ p: 0 }}>
          {Array.from(
            new Set(
              realEstate.LandParcelEntryArray.map(landParcel =>
                landParcel.idAdministrativeUnit === null
                  ? landParcel.LandRegister
                  : adminUnit.find(
                      admin =>
                        admin.idAdministrativeUnit ===
                        landParcel.idAdministrativeUnit
                    )?.AdministrativeUnit
              ).filter(Boolean)
            )
          ).join(', ') || '–'}
        </TableCell>
        {/* Flurstück(e): Flur + Flurstück je Eintrag zusammengefasst */}
        <TableCell sx={{ p: 0 }}>
          {realEstate.LandParcelEntryArray.map(landParcel =>
            [
              landParcel.Parcel ? `Flur ${landParcel.Parcel}` : null,
              landParcel.LandParcel
                ? `Flurstück ${landParcel.LandParcel}`
                : null,
            ]
              .filter(Boolean)
              .join(' · ')
          )
            .filter(Boolean)
            .join(', ') || '–'}
        </TableCell>
        {/* Blatt — einheitlich als Chip(s), wie in VorgangBlattRow (#1164) */}
        <TableCell sx={{ p: 0 }}>
          {(() => {
            const blaetter = Array.from(
              new Set(
                realEstate.LandParcelEntryArray.map(
                  landParcel => landParcel.SheetLandRegister
                ).filter(Boolean)
              )
            );
            return blaetter.length === 0 ? (
              '–'
            ) : (
              <Stack direction='row' spacing={0.5} flexWrap='wrap' useFlexGap>
                {blaetter.map(b => (
                  <Chip
                    key={String(b)}
                    size='small'
                    color='primary'
                    variant='filled'
                    label={b}
                  />
                ))}
              </Stack>
            );
          })()}
        </TableCell>

        <TableCell>
          <LandRegisterMainQueryDocument
            realEstateLandRegisterEntryQueries={
              realEstateLandRegisterEntryQueries || []
            }
            legalPhaseFullObjectArray={legalPhaseFullObjectArray}
            legalReqStates={legalReqStates}
            setLegalPhaseFullObjectArray={setLegalPhaseFullObjectArray}
          />
        </TableCell>

        <TableCell>
          <Tooltip title='Grundbuchblatt öffnen (Bestandsverzeichnis / Abteilungen I–III)'>
            <IconButton color='primary' onClick={() => setIsOpenBlatt(true)}>
              <MenuBook />
            </IconButton>
          </Tooltip>
          <Tooltip title='Grundstück aus dem Vorgang entfernen'>
            <IconButton
              onClick={() =>
                setRealEstateArray(
                  realEstateArray.filter(
                    re => re.idRealEstate !== realEstate.idRealEstate
                  )
                )
              }
            >
              <Delete />
            </IconButton>
          </Tooltip>
          <QueryLandRegisterDialog
            realEstateObject={realEstate}
            setRealEstateObject={(
              updatededRealEstate: ILegalTransactionRelationshipRealEstate
            ) => {
              setEditRealEstate(updatededRealEstate);
              saveObject(updatededRealEstate);
            }}
            realEstateLandRegisterEntryQueries={
              realEstateLandRegisterEntryQueries || []
            }
            refetchRealEstateLandRegisterEntryQueries={
              refetchRealEstateLandRegisterEntryQueries
            }
            legalTransaction={legalTransaction}
          />
          {/*
          <IconButton onClick={() => setOpenLandregisterSerach(true)}>
            <Policy />
          </IconButton>
           */}
        </TableCell>
      </TableRow>
    </>
  );
};
